/**
 * @fileoverview Menu component config model.
 */
goog.declareModuleId('yext.ui.components.menu.types.config');

import {TriggerComponent} from '/ui/components/dropdowntrigger/dropdowntrigger';
import {Action} from '/ui/components/menu/types/action';

/**
 * @enum {symbol}
 */
export const NestingMode = {
  GROUP: Symbol('GROUP'),
  CASCADE: Symbol('CASCADE'),
};

/**
 * @typedef {{
 *   actions: !Array<!Action>,
 *   alignMenu?: string,
 *   allowContainerOverflow?: boolean,
 *   ariaLabel?: string,
 *   disabled?: boolean,
 *   dropdownButtonRef?: (React.RefObject<HTMLElement>|null),
 *   dropdownTriggerClass?: string,
 *   enableSearch?: boolean,
 *   isContextual?: boolean,
 *   label?: !React.ReactNode,
 *   nestingMode?: NestingMode,
 *   onDropdownStateChange?: (function(boolean): void),
 *   primary?: boolean,
 *   ghost?: boolean,
 *   showDefaultAction?: boolean,
 *   tid?: string,
 *   pendoId?: string,
 *   trigger?: TriggerComponent,
 *   wrapperClassName?: string,
 * }}
 */
export let Config;
